import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SearchBar.css';

// A text box and Search button. Searching opens the results screen; `within` limits it
// to everything beneath one place.
function SearchBar({ within, placeholder, initial = '' }) {
  const navigate = useNavigate();
  const [text, setText] = useState(initial);

  const submit = (event) => {
    event.preventDefault();
    const q = text.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}${within ? `&within=${within}` : ''}`);
  };

  return (
    <form className="search-bar" onSubmit={submit} role="search">
      <input
        type="search"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        autoComplete="off"
        enterKeyHint="search"
      />
      <button type="submit" className="btn btn-primary" disabled={!text.trim()}>
        Search
      </button>
    </form>
  );
}

export default SearchBar;
